module.exports = "<button class=\"default\" [ngClass]=\"inputClass\" (click)=\"close.emit(true)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/close-btn.component/close-btn.component.html
// module id = ./src/app/shared/components/close-btn.component/close-btn.component.html
// module chunks = main